module.exports = __webpack_public_path__ + "static/solace-dd3f6c1d9ccda57dcf3b45c6b815369e.png";